// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import produce from 'immer';
import { SUBJECTS_SLUGS_TYPE } from 'platform-components/src/typings';

import { FILTER_SCHOOLBOOKS, SELECT_SCHOOLBOOK } from './constants';
import { UMKModalStoreState, UMKModalAction, UMKModalSubjectData } from './typings';

const initialState = Object.values(SUBJECTS_SLUGS).reduce(
    (acc: Record<SUBJECTS_SLUGS_TYPE, UMKModalSubjectData>, subject: SUBJECTS_SLUGS_TYPE) => {
        acc[subject] = {
            selectedSchoolbookId: null,
            query: null,
        };

        return acc;
    },
    {}
);

const UMKModalReducer = (state: UMKModalStoreState = initialState as UMKModalStoreState, action: UMKModalAction) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SELECT_SCHOOLBOOK: {
                const { schoolbookId, subject } = action;

                draft[subject].selectedSchoolbookId = schoolbookId;
                break;
            }
            case FILTER_SCHOOLBOOKS: {
                const { input, subject } = action;

                draft[subject].query = input;
                break;
            }
            default:
                break;
        }
    });
};

export default UMKModalReducer;
